/** Shared React Query keys for Context Designer data and its explicit refresh action. */
export const contextDesignerQueryKeys = {
	subDomains: () => ['subDomains'] as const,
	designerSnapshot: (contextId: string, includeCode: boolean) => ['contextDesignerSnapshot', contextId, includeCode] as const,
	context: (contextId: string) => ['context', contextId] as const,
	domainModel: (contextId: string) => ['domainModel', contextId] as const,
	operations: (contextId: string) => ['operations', contextId] as const,
	artifactLayout: (contextId: string) => ['contextArtifactLayout', contextId] as const,
	codeArtifacts: (contextId: string) => ['contextCodeArtifacts', contextId] as const,
	availableServiceConnections: () => ['contextAvailableServiceConnections'] as const,
	serviceConnectionMetadata: () => ['serviceConnectionMetadata'] as const,
	isDesignerSnapshot: (queryKey: readonly unknown[]) => queryKey[0] === 'contextDesignerSnapshot',
	isForContext: (queryKey: readonly unknown[], contextId: string) => queryKey.some((part) => part === contextId),
};
